import React, { useRef, useEffect } from 'react';
import lottie from 'lottie-web';
// import data from "./data.svg"
// for animated svgs use json file
export default function CertImg() {
  const container = useRef(null);
  useEffect(() => {
    const instance = lottie.loadAnimation({
      container: container.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require('./cert.json'),
    });
    // Return clean up function here
    return () => instance.destroy();
  }, []);
  return (
    <div className="App">
      <div className="container CertImage" ref={container}></div>
    </div>
  );
}
